import requestSender from "@/api/base/requestSender";

const UrlPrefix = "oneToOne/";

export default function (axiosInstance) {
  return {

    // Meetings
    meetingSearch(payload, options) {
      return requestSender("get", UrlPrefix + "meeting/search", payload, options);
    },
    meetingView(payload, options) {
      return requestSender("get", UrlPrefix + "meeting/view", payload, options);
    },
    meetingCreate(payload, options) {
      return requestSender("post", UrlPrefix + "meeting/create", payload, options);
    },
    meetingUpdate(payload, options) {
      return requestSender("post", UrlPrefix + "meeting/update", payload, options);
    },
    meetingFinish(payload, options) {
      return requestSender("post", UrlPrefix + "meeting/finish", payload, options);
    },
    meetingCancel(payload, options) {
      return requestSender("post", UrlPrefix + "meeting/cancel", payload, options);
    },

    // Agenda blocks
    agendaBlockGetByMeeting(payload, options) {
      return requestSender("get", UrlPrefix + "agenda-block/get-by-meeting", payload, options);
    },
    agendaBlockCreate(payload, options) {
      return requestSender("post", UrlPrefix + "agenda-block/create", payload, options);
    },
    agendaBlockUpdate(payload, options) {
      return requestSender("post", UrlPrefix + "agenda-block/update", payload, options);
    },
    agendaBlockComplete(payload, options) {
      return requestSender("post", UrlPrefix + "agenda-block/complete", payload, options);
    },
    agendaBlockDelete(payload, options) {
      return requestSender("post", UrlPrefix + "agenda-block/delete", payload, options);
    },

    // Notes
    noteCreate(payload, options) {
      return requestSender("post", UrlPrefix + "note/create", payload, options);
    },
    noteUpdate(payload, options) {
      return requestSender("post", UrlPrefix + "note/update", payload, options);
    },
    noteDelete(payload, options) {
      return requestSender("post", UrlPrefix + "note/delete", payload, options);
    },

    // Agreements
    agreementCreate(payload, options) {
      return requestSender("post", UrlPrefix + "agreement/create", payload, options);
    },
    agreementMarkDone(payload, options) {
      return requestSender("post", UrlPrefix + "agreement/mark-done", payload, options);
    },
    agreementDelete(payload, options) {
      return requestSender("post", UrlPrefix + "agreement/delete", payload, options);
    },

    // Protocol
    protocolView(payload, options) {
      return requestSender("get", UrlPrefix + "protocol/view", payload, options);
    },
    protocolUpdate(payload, options) {
      return requestSender("post", UrlPrefix + "protocol/update", payload, options);
    },
    protocolFix(payload, options) {
      return requestSender("post", UrlPrefix + "protocol/fix", payload, options);
    },

  };
}